import { render, staticRenderFns } from "./products_brand.vue?vue&type=template&id=efa4d216&"
import script from "./products_brand.vue?vue&type=script&lang=js&"
export * from "./products_brand.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports